import { Injectable, Testability } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { TimeUtils } from '@freelancer/time-utils';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PendingTasks {
  constructor(
    private router: Router,
    private timeUtils: TimeUtils,
    private testability: Testability,
  ) {}

  monitor(): void {
    this.router.events
      .pipe(filter((event: Event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let timerDone = false;
        const timeoutId = this.timeUtils.setTimeout(() => {
          timerDone = true;
        }, 10_000);
        this.testability.whenStable(
          (e: any) => {
            clearTimeout(timeoutId);
          },
          0,
          (pendingTasks: any) => {
            if (timerDone) {
              console.warn(
                'Pending tasks blocking zone stabilization:',
                pendingTasks,
              );
              pendingTasks.forEach((task: any) => {
                if (task.data.url) {
                  console.warn(
                    `Pending task: ${task.source}: ${task.data.url}`,
                  );
                } else {
                  console.warn(
                    `Pending task: ${task.source}: ${task.creationLocation.stack}`,
                  );
                }
              });
            }
          },
        );
      });
  }
}
